import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

const defaultEl = {
  id: null,
  pdf_template: null,
  material_group: null,
  year: '',
  number: '',
  info: {
    dateandloc: ''
  }
};

export default {
  name: 'RegenTemplatesEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  validations: {
    editEl: {
      pdf_template: { required },
      material_group: { required },
      year: { required },
      number: {}
    }
  },
  computed: {
    ...mapState(['config']),
    infoParams () {
      return Object.keys(defaultEl.info);
    },
    pdfTemplateOptions () {
      return this.$store.getters.getConfigOptions('pdf_templates', this.$i18n.locale);
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    yearOptions () {
      if (this.config);
      const perConfig = (this.config ? this.config.datePeriodConfig : null);
      if (perConfig) {
        const options = [];
        let year = perConfig.endYear;
        while (year >= perConfig.startYear) {
          options.push({ value: year, label: year });
          year -= 1;
        }
        return options;
      }
      return [];
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.regen-templates.edit');
      }
      return this.$t('menu.config.regen-templates.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.info = this.editEl.info.lv;
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.editEl.pdf_template = this.$store.getters.getParamFromConfig('pdf_templates', this.editEl.pdf_template_id, 'code');
      this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        reqData.info = { lv: reqData.info };
        const self = this;
        this.ApiRequest.request('regen-templates/edit', this.ApiRequest.REQUEST_POST, { item: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
